import qz from "./qz";
import dateFns from "date-fns";

// Check if we're in development mode or if preview mode is forced via URL parameter
const isDevelopment =
  process.env.NODE_ENV === "development" ||
  window.location.hostname === "localhost";
const forcePreview =
  new URLSearchParams(window.location.search).get("preview") === "true";

const prepareData = (data, type) => {
  if (type === "sale") {
    const products = data.productList.map(i => {
      return {
        name: i.name,
        qty: i.quantity,
        rate: i.rate,
        total: i.amount
      };
    });
    const formatedDate = dateFns.format(new Date(data.date), "DD/MM/YYYY");

    const meta = {
      subTotal: data.finalTotal,
      grandTotal: data.grandTotal,
      date: formatedDate,
      name: `${data.userData.firstName} ${data.userData.lastName}`,
      discount: data.isPercentage
        ? `${data.discount} %`
        : `Rs. ${data.discount}`,
      roundOff: data.roundOff || 0
    };
    return {
      products,
      meta
    };
  } else if (type === "chalan") {
    const products = data.chalanItems.map(i => {
      return {
        name: i.name,
        qty: i.quantity,
        rate: i.price,
        total: i.total
      };
    });
    const formatedDate = dateFns.format(new Date(data.updatedAt), "DD/MM/YYYY");

    const meta = {
      subTotal: data.subTotal,
      roundOff: data.roundedOff,
      grandTotal: data.grandTotal,
      date: formatedDate,
      name: `${data.users.firstName} ${data.users.lastName}`,
      phone: data.users.phone,
      vendor: `${data.vendor.firstName} ${data.vendor.lastName}`,
      chalanNumber: data.chalanNumber,
      chalanType: data.isInward ? "Inward" : "Outward"
    };
    return {
      products,
      meta
    };
  } else if (type === "quotation") {
    const products = data.products.map(i => {
      return {
        name: i.name,
        qty: i.quantity,
        rate: i.price,
        total: i.amount
      };
    });
    const formatedDate = dateFns.format(new Date(data.updatedAt), "DD/MM/YYYY");
    const meta = {
      subTotal: data.finalTotal,
      grandTotal: data.grandTotal,
      date: formatedDate,
      name: `${data.user.firstName} ${data.user.lastName}`,
      phone: data.user.phone
    };
    return {
      products,
      meta
    };
  } else if (type === "sale-quotation") {
    const products = data.productMeta.map(i => {
      return {
        name: i.name,
        qty: i.quantity,
        rate: i.price,
        total: i.quantity * i.price
      };
    });
    const formatedDate = dateFns.format(new Date(data.createdAt), "DD/MM/YYYY");
    const meta = {
      subTotal: data.total,
      grandTotal: data.total,
      date: formatedDate,
      name: `${data.quotationUser.firstName} ${data.quotationUser.lastName}`,
      phone: data.quotationUser.phone
    };
    return {
      products,
      meta
    };
  } else if (type === "customer-chalan") {
    const products = data.products.map(i => {
      return {
        name: i.name,
        qty: i.quantity,
        rate: i.price,
        total: i.total
      };
    });
    const formatedDate = dateFns.format(new Date(data.createdAt), "DD/MM/YYYY");
    const meta = {
      subTotal: data.subTotal,
      grandTotal: data.grandTotal,
      roundOff: data.roundedOff,
      date: formatedDate,
      name: data.user,
      phone: data.user.phone,
      chalanNumber: data.chalanNumber,
      chalanType: data.is_inward ? "Inward" : "Outward"
    };
    return {
      products,
      meta
    };
  }
};

// Function to generate HTML preview for local development
const generateHTMLPreview = (products, meta, type) => {
  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Print Preview - ${type}</title>
      <style>
        body {
          font-family: 'Courier New', monospace;
          width: 300px;
          margin: 0 auto;
          padding: 20px;
          background: white;
          color: black;
        }
        .header {
          text-align: center;
          font-weight: bold;
          font-size: 18px;
          margin-bottom: 10px;
        }
        .company-name {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 5px;
        }
        .address {
          font-size: 12px;
          line-height: 1.3;
          margin-bottom: 10px;
        }
        .date {
          text-align: left;
          margin-bottom: 10px;
        }
        .separator-line {
          border-top: 1px dashed black;
          margin: 10px 0;
        }
        .customer-info {
          margin-bottom: 10px;
        }
        .chalan-info {
          margin-bottom: 10px;
        }
        .table-header {
          font-weight: bold;
          margin-bottom: 5px;
          display: grid;
          grid-template-columns: 1fr 4fr 2fr 2fr 2fr;
        }
        .product-row {
          display: grid;
          grid-template-columns: 1fr 4fr 2fr 2fr 2fr;
          align-items: baseline;
          margin-bottom: 3px;
          font-size: 12px;
        }
        .product-name {
          display: inline-block;
          width: 120px;
        }
        .product-qty {
          display: inline-block;
          width: 30px;
          text-align: center;
        }
        .product-rate {
          display: inline-block;
          width: 50px;
          text-align: center;
        }
        .product-total {
          display: inline-block;
          width: 50px;
          text-align: center;
        }
        .totals {
          margin-top: 10px;
          font-weight: bold;
        }
        .total-row {
          margin-bottom: 3px;
        }
        .print-footer {
          margin-top: 20px;
          text-align: center;
          font-size: 10px;
        }
        @media print {
          body { margin: 0; padding: 10px; }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="company-name">${meta.company || 'Rajput Electricals'}</div>
        <div class="address">
          Shop no. 14, 15, Loksangam vihar, P building,<br>
          opp SVC Bank, aundh, Pune - 7<br>
          Contact: 8237478645, 8237478647, 020 25884004
        </div>
      </div>

      <div class="date">${meta.date}</div>

      <div class="separator-line"></div>

      <div class="customer-info">
        <strong>Customer:</strong> ${meta.name}<br>
        ${meta.phone ? `<strong>Phone:</strong> ${meta.phone}<br>` : ""}
      </div>

      ${
        type === "chalan"
          ? `
        <div class="vendor-info">
          <strong>Vendor:</strong> ${meta.vendor}<br>
        </div>
      `
          : ""
      }

      ${
        type === "customer-chalan" || type === "chalan"
          ? `
        <div class="chalan-info">
          <strong>Chalan Number:</strong> ${meta.chalanNumber}<br>
          <strong>Chalan Type:</strong> ${meta.chalanType}
        </div>
      `
          : ""
      }

      <div class="separator-line"></div>

      <div class="table-header">
        <span>#</span>
       <span>Item</span>
       <span>Qty</span>
       <span>Rate</span>
       <span>Total</span>
      </div>

      ${products
        .map(
          (item, index) => `
        <div class="product-row">
          <span>${index + 1}</span>
          <span class="product-name">${item.name}</span>
          <span class="product-qty">${item.qty}</span>
          <span class="product-rate">${item.rate}</span>
          <span class="product-total">${item.total}</span>
        </div>
      `
        )
        .join("")}

      <div class="separator-line"></div>

      <div class="totals">
        <div class="total-row">Subtotal: ${meta.subTotal}</div>
        ${
          meta.roundOff !== 0
            ? `<div class="total-row">Round Off: ${meta.roundOff}</div>`
            : ""
        }
        <div class="total-row">Total: ${meta.grandTotal}</div>
      </div>

      <div class="print-footer">
        <p>Thank you for your business!</p>
        <p>Generated on: ${new Date().toLocaleString()}</p>
      </div>
    </body>
    </html>
  `;

  return html;
};

// Function to show preview in modal
const showPreview = html => {
  // Create modal overlay
  const modalOverlay = document.createElement("div");
  modalOverlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  `;

  // Create modal content
  const modalContent = document.createElement("div");
  modalContent.style.cssText = `
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    max-width: 90%;
    max-height: 98%;
    overflow: auto;
    position: relative;
  `;

  // Create modal header
  const modalHeader = document.createElement("div");
  modalHeader.style.cssText = `
    padding: 15px 20px;
    border-bottom: 1px solid #e9ecef;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8f9fa;
    border-radius: 8px 8px 0 0;
  `;

  const modalTitle = document.createElement("h3");
  modalTitle.textContent = "Print Preview";
  modalTitle.style.cssText = `
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
  `;

  const closeButton = document.createElement("button");
  closeButton.innerHTML = "&times;";
  closeButton.style.cssText = `
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #666;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s;
  `;
  closeButton.onmouseover = () =>
    (closeButton.style.backgroundColor = "#e9ecef");
  closeButton.onmouseout = () =>
    (closeButton.style.backgroundColor = "transparent");

  // Create modal body
  const modalBody = document.createElement("div");
  modalBody.style.cssText = `
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
  `;

  // Create modal footer
  const modalFooter = document.createElement("div");
  modalFooter.style.cssText = `
    padding: 15px 20px;
    border-top: 1px solid #e9ecef;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    background: #f8f9fa;
    border-radius: 0 0 8px 8px;
  `;

  const printButton = document.createElement("button");
  printButton.innerHTML =
    isDevelopment || forcePreview
      ? "Print Preview"
      : "Print to Thermal Printer";
  printButton.style.cssText = `
    padding: 10px 20px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s;
  `;
  printButton.onmouseover = () =>
    (printButton.style.backgroundColor = "#0056b3");
  printButton.onmouseout = () =>
    (printButton.style.backgroundColor = "#007bff");

  const closeModalButton = document.createElement("button");
  closeModalButton.innerHTML = "Close";
  closeModalButton.style.cssText = `
    padding: 10px 20px;
    background: #6c757d;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s;
  `;
  closeModalButton.onmouseover = () =>
    (closeModalButton.style.backgroundColor = "#545b62");
  closeModalButton.onmouseout = () =>
    (closeModalButton.style.backgroundColor = "#6c757d");

  // Function to close modal
  const closeModal = () => {
    document.body.removeChild(modalOverlay);
    document.removeEventListener("keydown", handleEscapeKey);
  };

  // Handle escape key
  const handleEscapeKey = event => {
    if (event.key === "Escape") {
      closeModal();
    }
  };

  // Add event listeners
  closeButton.onclick = closeModal;
  closeModalButton.onclick = closeModal;
  printButton.onclick = () => {
    if (isDevelopment || forcePreview) {
      // In development mode, just print the HTML preview
      const printWindow = window.open("", "_blank", "width=400,height=600");
      printWindow.document.write(html);
      printWindow.document.close();
      printWindow.print();
    } else {
      // In production mode, proceed with thermal printing
      closeModal();
      // Call the thermal printing function
      proceedWithThermalPrint(sale, type);
    }
  };

  // Assemble modal
  modalHeader.appendChild(modalTitle);
  modalHeader.appendChild(closeButton);
  modalFooter.appendChild(closeModalButton);
  modalFooter.appendChild(printButton);

  modalContent.appendChild(modalHeader);
  modalContent.appendChild(modalBody);
  modalContent.appendChild(modalFooter);
  modalOverlay.appendChild(modalContent);

  // Add the preview content to modal body
  modalBody.innerHTML = html;

  // Add to document
  document.body.appendChild(modalOverlay);
  document.addEventListener("keydown", handleEscapeKey);

  // Focus the modal for keyboard navigation
  modalContent.focus();
};

// Function to proceed with thermal printing in production
const proceedWithThermalPrint = (sale, type, company = null) => {
  const { products, meta } = prepareData(sale, type);
  if (company) meta.company = company;

  const printWithConfig = printerName => {
    var config = qz.configs.create(printerName);
    var data = [
      "\x1B" + "\x40", // init
      "\x1B" + "\x61" + "\x31", // center align
      "\x1B" + "\x45" + "\x0D", // bold
      "\x1b\x21\x01",
      "\x1b\x21\x11",
      "\x1b\x21\x20",
      (meta.company || "Rajput Electricals") + "\x0A",
      "\x1b\x21\x00",
      "\x1B" + "\x45" + "\x0A",
      "Shop no. 14, 15, Loksangam vihar, P building," + "\x0A", // text and line break
      "opp SVC Bank, aundh, Pune - 7" + "\x0A", // line break
      "Contact: 8237478645, 8237478647, 020 25884004" + "\x0A",
      "\x1B" + "\x61" + "\x30\x0A", // left align   // line break
      meta.date + "\x0A",

      "------------------------------------------------" + "\x0A",
      "Customer: " + meta.name + "\x0A",
      ...(type === "customer-chalan"
        ? [
            "Chalan Number: " + meta.chalanNumber + "\x0A",
            "Chalan Type: " + meta.chalanType + "\x0A"
          ]
        : []),
      ...(type === "chalan"
        ? [
            "Vendor: " + meta.vendor + "\x0A",
            "Chalan Number: " + meta.chalanNumber + "\x0A",
            "Chalan Type: " + meta.chalanType + "\x0A"
          ]
        : []),
      "------------------------------------------------" + "\x0A",
      "#  " +
        "Item" +
        "                    " +
        "Qty" +
        "  " +
        "Rate" +
        "    " +
        "Total" +
        "\x0A"
    ];

    // Define column widths for proper alignment
    const colWidths = {
      item: 20, // Item name column
      qty: 4, // Quantity column
      rate: 8, // Rate column
      total: 8 // Total column
    };

    products.forEach((item, index) => {
      const itemNumber = (index + 1).toString();
      const itemName = item.name;
      const qty = item.qty.toString();
      const rate = item.rate.toString();
      const total = item.total.toString();

      // Handle long item names by splitting them
      if (itemName.length > colWidths.item) {
        // First line with item number and truncated name
        const firstLine =
          itemNumber.padEnd(3) +
          itemName.substr(0, colWidths.item) +
          qty.padStart(colWidths.qty) +
          rate.padStart(colWidths.rate) +
          total.padStart(colWidths.total) +
          "\x0A";
        data.push(firstLine);

        // Additional lines for remaining item name
        let remainingName = itemName.substr(colWidths.item);
        while (remainingName.length > 0) {
          const lineName = remainingName.substr(0, colWidths.item);
          const line =
            "   " + // 3 spaces to align with item name
            lineName.padEnd(
              colWidths.item + colWidths.qty + colWidths.rate + colWidths.total
            ) +
            "\x0A";
          data.push(line);
          remainingName = remainingName.substr(colWidths.item);
        }
      } else {
        // Single line for normal length item names
        const line =
          itemNumber.padEnd(3) +
          itemName.padEnd(colWidths.item) +
          qty.padStart(colWidths.qty) +
          rate.padStart(colWidths.rate) +
          total.padStart(colWidths.total) +
          "\x0A";
        data.push(line);
      }
    });
    data.push("------------------------------------------------" + "\x0A");
    data.push("\x1B" + "\x45" + "\x0D"); // bold

    // Calculate right alignment position for totals (align with the rightmost column)
    const totalAlignPosition =
      colWidths.item + colWidths.qty + colWidths.rate + colWidths.total;

    // Subtotal
    const subtotalLine =
      "Subtotal:".padEnd(totalAlignPosition - meta.subTotal.toString().length) +
      meta.subTotal +
      "\x0A";
    data.push(subtotalLine);

    // Round off (if applicable)
    if (meta.roundOff !== 0) {
      const roundOffLine =
        "Round Off:".padEnd(
          totalAlignPosition - meta.roundOff.toString().length
        ) +
        meta.roundOff +
        "\x0A";
      data.push(roundOffLine);
    }

    // Grand Total
    const totalLine =
      "Total:".padEnd(totalAlignPosition - meta.grandTotal.toString().length) +
      meta.grandTotal +
      "\x0A";
    data.push(totalLine);
    data.push("\x1B" + "\x45" + "\x0A"); // unbold
    data.push("\x0A" + "\x0A" + "\x0A" + "\x0A" + "\x0A" + "\x0A" + "\x0A");
    data.push("\x1B" + "\x69");
    data.push("\x10" + "\x14" + "\x01" + "\x00" + "\x05");
    if (qz.websocket.isActive()) {
      qz.print(config, data)
        .then(function() {
          console.log("Sent data to printer");
        })
        .catch(function(e) {
          console.log(e);
        });
    } else {
      qz.websocket
        .connect()
        .then(function() {
          qz.print(config, data)
            .then(function() {
              console.log("Sent data to printer");
            })
            .catch(function(e) {
              console.log(e);
            });
        })
        .catch(function(e) {
          console.error(e);
          console.log("you are already connected!");
        });
    }
  };

  if (qz.websocket.isActive()) {
    qz.printers
      .getDefault()
      .then(printer => {
        printWithConfig(printer);
      })
      .catch(e => {
        console.error("Error getting default printer:", e);
        alert(
          "Error getting default printer. Please check your printer settings."
        );
      });
  } else {
    qz.websocket
      .connect()
      .then(() => {
        qz.printers
          .getDefault()
          .then(printer => {
            console.log("printer", printer);
            printWithConfig(printer);
          })
          .catch(e => {
            console.error("Error getting default printer:", e);
            alert(
              "Error getting default printer. Please check your printer settings."
            );
          });
      })
      .catch(e => {
        console.error(e);
        console.log("you are already connected!");
      });
  }
};

export function print(sale, type = "sale", company = null) {
  const { products, meta } = prepareData(sale, type);
  if (company) meta.company = company;

  // Always show preview first (both in development and production)
  console.log("Showing print preview");
  console.log("Print data:", { products, meta, type });
  const html = generateHTMLPreview(products, meta, type);

  // Show preview in modal
  showPreview(html);

  // In development mode, don't proceed to actual printing
  if (isDevelopment || forcePreview) {
    console.log("Development mode: Preview only, no actual printing");
    return;
  }

  proceedWithThermalPrint(sale, type, company);

  // In production, the user can choose to print from the modal
  // The thermal printing logic is now handled in proceedWithThermalPrint function
}
